
import React from 'react';
import { Contestant } from '../types';

interface ContestantCardProps {
  contestant: Contestant;
  onSelect: (c: Contestant) => void;
}

const ContestantCard: React.FC<ContestantCardProps> = ({ contestant, onSelect }) => {
  return (
    <div 
      className="group relative rounded-2xl overflow-hidden bg-slate-800 cursor-pointer shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-pink-500/20"
      onClick={() => onSelect(contestant)}
    >
      <div className="aspect-video overflow-hidden">
        <img 
          src={contestant.image} 
          alt={contestant.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      
      {/* Overlay - Adjusted for landscape */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-70 group-hover:opacity-90 transition-opacity"></div>
      
      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-4 transform transition-transform duration-500">
        <div className="flex items-center justify-between mb-1">
          <span className="px-2 py-0.5 bg-pink-600 text-[9px] font-bold uppercase rounded-md tracking-tighter">Season {contestant.season}</span>
          <div className="w-8 h-8 rounded-full bg-pink-500 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 shadow-lg shadow-pink-500/50">
             <i className="fas fa-play text-[10px] ml-0.5"></i>
          </div>
        </div>
        <h3 className="text-lg font-playfair font-bold text-white group-hover:text-pink-400 transition-colors">{contestant.name}</h3>
        <p className="text-slate-300 text-[10px] line-clamp-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300 italic">"{contestant.tagline}"</p>
      </div>

      {/* Glow Effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-2xl blur opacity-0 group-hover:opacity-10 transition-opacity -z-10"></div>
    </div>
  );
};

export default ContestantCard;
